<template>
  <relatorio-gestao titulo="Anexo 1 4.320: Receita e Despesa segundo a Categoria Econômica"
    :gerarRelatorio="gerarRelatorio" :loading="loading" :pdfData="pdfData">
    <b-row>
      <b-col cols="6" xl="2">
        <b-form-group id="input-group-exercicio" label="Exercício *" label-for="input-exercicio" label-class="text-left">
          <b-form-select id="input-exercicio" v-model="filtros.exercicio" :options="exercicios">
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </relatorio-gestao>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import RelatorioGestao from '@/components/RelatorioGestao.vue'
import reportService from '@/services/reportService'
import { UtilsTS } from '@/utilsts'
import { FiltrosGestao } from '@/types/relatorios/filtros-gestao'

const CompProps = Vue.extend({
  name: 'RelatorioGestaoPcaReceitaDespesaPorCatEconomica',
  components: { RelatorioGestao },
})

@Component
export default class RelatorioGestaoPcaReceitaDespesaPorCatEconomica extends mixins(UtilsTS, CompProps) {
  pdfData: any = ''
  exercicios: string[] = []
  loading = false
  filtros: FiltrosGestao = new FiltrosGestao()

  async gerarRelatorio(): Promise<void> {
    try {
      this.pdfData = '';
      this.loading = true;
      if (this.validarFiltros()) {
        const response = await reportService.getRelatorioGestao('ReceitaDespesaPorCatEconomica', this.filtros)
        this.pdfData = response.ArquivoPdf
      }
    } catch (e: any) {
      this.tratarError(e)
    } finally {
      this.loading = false;
    }
  }

  validarFiltros(): boolean {
    if (!this.filtros.exercicio || this.filtros.exercicio < 2017) {
      this.$toast.error('Exercício é obrigatório')
      return false
    }
    return true
  }

  async mounted() {
    this.filtros.exercicio = 0
    this.exercicios = this.getListaAnos2017ateAnoAtual()
  }
}
</script>